import React from 'react';
import { LAYOUT } from '../../styles/constants';
import useMediaQuery from '../../hooks/useMediaQuery';

interface BoxedLayoutProps {
  children: React.ReactNode;
}

const BoxedLayout = ({ children }: BoxedLayoutProps) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <div className="min-h-screen bg-gray-100 flex justify-center">
      <div 
        className="bg-white shadow-xl w-full flex flex-col"
        style={{ 
          maxWidth: LAYOUT.WEBSITE_WIDTH,
          minHeight: isDesktop ? LAYOUT.WEBSITE_HEIGHT : 'auto'
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default BoxedLayout;